import { render } from "./dl-imagebase64.vue?vue&type=template&id=717b1695"
import script from "./dl-imagebase64.vue?vue&type=script&lang=js"
export * from "./dl-imagebase64.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__